export default __webpack_public_path__ + "static/media/close-modal-icon.85cfffe4.svg";